import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'
import {
  Panel,
  Message,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  DatePicker,
  RadioGroup,
  Radio,
  SelectPicker,
  CheckPicker,
  Uploader,
  Icon,
  Checkbox,
  ButtonGroup,
  IconButton,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import {
  updateMasterReviewer,
  getMasterReviewerFileById,
} from '../../../redux/actions/masterReviewer'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import moment from 'moment'
import classNames from 'classnames'
import { DATE_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import AppContext from '../../../context/AppContext'
import { isEmpty } from 'lodash-es'
import { downloadFile, previewFile } from '../../../utils/fileUtil'

export default function ExpertEditDetailWidget(props) {
  const { schema, showCommandButton, isEdit, onChangeIsEdit, editSuccess, onCancel } = props

  const { theme } = React.useContext(AppContext)

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(schema)
  const [allValue, setAllValue] = useState(schema.expertiseType.options.map((item) => item.value))
  const [fileErr, setFileErr] = useState()
  const [showOtherNationality, setShowOtherNationality] = useState(schema.nationality?.value === 2)
  const [expertiseTypeSelected, setExpertiseTypeSelected] = useState(
    schema.expertiseType.value || []
  )

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('useEffect schema', schema)
    if (schema) {
      setValue(schema.prefixName.name, schema.prefixName.value || '')
      setValue(schema.firstName.name, schema.firstName.value || '')
      setValue(schema.lastName.name, schema.lastName.value || '')
      setValue(schema.idCard.name, schema.idCard.value || '')
      setValue(schema.nationality.name, schema.nationality.value || 1)
      setValue(
        schema.nationality.nationalityOther.name,
        schema.nationality.nationalityOther.value || ''
      )
      setValue(schema.effectiveDateStart.name, schema.effectiveDateStart.value || '')
      setValue(schema.effectiveDateEnd.name, schema.effectiveDateEnd.value || '')
      setValue(schema.budgetYear.name, schema.budgetYear.value || 0)
      setValue(schema.reviewType.name, schema.reviewType.value || 1)
      setValue(schema.bankName.name, schema.bankName.value || '')
      setValue(schema.branchOfBank.name, schema.branchOfBank.value || '')
      setValue(schema.bankAccountNo.name, schema.bankAccountNo.value || '')
      setValue(schema.assignNo.name, schema.assignNo.value || '')
      setValue(schema.refFile.name, schema.refFile.value || null)
      setValue(schema.accountType.name, schema.accountType.value || '')
      setValue(schema.expertiseType.name, schema.expertiseType.value || [])
      setFormSchema(schema)
    }
  }, [schema.id])

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      var response = await updateMasterReviewer(formSchema?.id, request)
      console.log('response', response)
      if (response) {
        editSuccess()
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || 'ไม่สำเร็จ')
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)
    console.log('expertiseTypeSelected', expertiseTypeSelected)
    const formData = new FormData()

    data.refFile &&
      data.refFile?.forEach((element) => {
        formData.append('file', element.blobFile)
      })

    formData.append('IdCard', data.idCard || '')
    formData.append('PrefixName', data.prefixName || '')
    formData.append('FirstName', data.firstName || '')
    formData.append('LastName', data.lastName || '')
    formData.append('Nationality', data.nationality.toString() || '')
    formData.append('NationalityOther', data.nationalityOther || '')
    formData.append(
      'EffectiveDateStart',
      moment(data.effectiveDateStart).format('YYYY/MM/DD') || ''
    )
    formData.append('EffectiveDateEnd', moment(data.effectiveDateEnd).format('YYYY/MM/DD') || '')
    formData.append('BudgetYear', data.budgetYear || 0)
    formData.append('ReviewType', data.reviewType.toString() || '')
    formData.append('AssignNo', data.assignNo || '')
    formData.append('AccountType', data.accountType || '')

    expertiseTypeSelected &&
      expertiseTypeSelected?.forEach((element) => {
        formData.append('ExpertiseType', element)
      })

    formData.append('BankName', data.bankName || '')
    formData.append('BranchOfBank', data.branchOfBank || '')
    formData.append('BankAccountNo', data.bankAccountNo || '')

    console.log('formData', formData)

    handleCallService(formData)
  }

  const handleFile = async (type, id, fileName) => {
    try {
      const file = await getMasterReviewerFileById(id)

      if (type == 'download') {
        downloadFile(file, fileName)
      } else {
        previewFile(file, fileName)
      }
    } catch (e) {
      setFileErr(`${type == 'download' ? 'ดาวน์โหลด' : 'แสดง'}ไฟล์ ${fileName} ไม่สำเร็จ`)
    }
  }

  return (
    <Panel
      shaded
      header={formSchema.hedaer}
      collapsible
      defaultExpanded={true}
      ref={(section) => {
        setSection(section)
      }}
    >
      <Row>
        {formSchema.prefixName && (
          <Col xs={24} sm={4} md={4} lg={4} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.prefixName.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.prefixName.validators, formSchema.prefixName.label)}
            </ControlLabel>
            <Controller
              name={formSchema.prefixName.name}
              control={control}
              defaultValue={formSchema.prefixName.value}
              rules={isValidators(formSchema.prefixName.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.prefixName.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        )}

        {formSchema.firstName && (
          <Col xs={24} sm={6} md={6} lg={6} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.firstName.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.firstName.validators, formSchema.firstName.label)}
            </ControlLabel>
            <Input
              name={formSchema.firstName.name}
              defaultValue={formSchema.firstName.value}
              inputRef={register(isValidators(formSchema.firstName.validators))}
              placeholder={'ระบุ' + formSchema.firstName.label}
            />
          </Col>
        )}

        {formSchema.lastName && (
          <Col xs={24} sm={6} md={6} lg={6} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.lastName.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.lastName.validators, formSchema.lastName.label)}
            </ControlLabel>
            <Input
              name={formSchema.lastName.name}
              defaultValue={formSchema.lastName.value}
              inputRef={register(isValidators(formSchema.lastName.validators))}
              placeholder={'ระบุ' + formSchema.lastName.label}
            />
          </Col>
        )}

        {formSchema.idCard && (
          <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.idCard.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.idCard.validators, formSchema.idCard.label)}
            </ControlLabel>
            <Controller
              name={formSchema.idCard.name}
              control={control}
              defaultValue={formSchema.idCard.value}
              rules={isValidators(formSchema.idCard.validators)}
              render={(props) => {
                return (
                  <Input
                    placeholder={formSchema.idCard.label}
                    value={props.value}
                    maxLength={getMaxLengthData(formSchema.idCard.validators).value}
                    onChange={(value, e) => {
                      if (isNaN(value)) {
                        return
                      }
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        )}

        <Col
          xs={24}
          sm={4}
          md={4}
          lg={4}
          style={{ marginTop: '10px', marginLeft: 5, width: 195, marginBottom: -20 }}
        >
          <ErrorMessage error={errors[formSchema.nationality.name]} />
          <ControlLabel>
            <p>{requiredFiled(formSchema.nationality.validators, formSchema.nationality.label)}</p>
          </ControlLabel>
          <Controller
            name={formSchema.nationality.name}
            control={control}
            defaultValue={formSchema.nationality.value}
            rules={isValidators(formSchema.nationality.validators)}
            render={(props) => {
              return (
                <RadioGroup
                  name="radioList"
                  inline
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                    if (value === 2) {
                      setShowOtherNationality(true)
                    } else {
                      setShowOtherNationality(false)
                    }
                  }}
                >
                  {formSchema.nationality?.options &&
                    formSchema.nationality.options.map((item) => (
                      <Radio key={item.value} value={item.value}>
                        {item.label}
                      </Radio>
                    ))}
                  {/* <Radio value="OTHER">อื่นๆ</Radio> */}
                </RadioGroup>
              )
            }}
          />
        </Col>
        {showOtherNationality && (
          <Col xs={24} sm={4} md={4} lg={4} style={{ marginTop: 31 }}>
            <Input
              name={formSchema.nationality.nationalityOther.name}
              placeholder={formSchema.nationality.nationalityOther.label}
              defaultValue={formSchema.nationality.nationalityOther.value}
              inputRef={register(
                isValidators(formSchema.nationality?.nationalityOther?.validators)
              )}
            />
          </Col>
        )}

        {formSchema.effectiveDateStart && (
          <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                'style-text-lable',
                isRequired(formSchema.effectiveDateStart.validators) && 'required'
              )}
            >
              {formSchema.effectiveDateStart.label}
            </ControlLabel>
            <ErrorMessage error={errors.effectiveDateStart} />
            <Controller
              name={formSchema.effectiveDateStart.name}
              control={control}
              defaultValue={
                formSchema.effectiveDateStart.value
                  ? moment(formSchema.effectiveDateStart.value, DATE_FORMAT).toDate()
                  : null
              }
              rules={isValidators(formSchema.effectiveDateStart.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    placement="auto"
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        )}

        {formSchema.effectiveDateEnd && (
          <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                'style-text-lable',
                isRequired(formSchema.effectiveDateEnd.validators) && 'required'
              )}
            >
              {formSchema.effectiveDateEnd.label}
            </ControlLabel>
            <ErrorMessage error={errors.effectiveDateEnd} />
            <Controller
              name={formSchema.effectiveDateEnd.name}
              control={control}
              defaultValue={
                formSchema.effectiveDateEnd.value
                  ? moment(formSchema.effectiveDateEnd.value, DATE_FORMAT).toDate()
                  : null
              }
              rules={isValidators(formSchema.effectiveDateEnd.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    placement="auto"
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        )}

        {formSchema.budgetYear && (
          <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.budgetYear.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.budgetYear.validators, formSchema.budgetYear.label)}
            </ControlLabel>
            <Input
              name={formSchema.budgetYear.name}
              defaultValue={formSchema.budgetYear.value}
              inputRef={register(isValidators(formSchema.budgetYear.validators))}
              placeholder={'ระบุ' + formSchema.budgetYear.label}
            />
          </Col>
        )}

        {formSchema.reviewType && (
          <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: 10, width: 200 }}>
            <ErrorMessage error={errors[formSchema.reviewType.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.reviewType.validators, formSchema.reviewType.label)}
            </ControlLabel>
            <Controller
              name={formSchema.reviewType.name}
              control={control}
              defaultValue={formSchema.reviewType.value || 1}
              rule={register(isValidators(formSchema.reviewType.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    style={{ height: 36 }}
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchema.reviewType.options.map((item) => (
                      <Radio key={item.value} value={item.value} disabled={formSchema.disabled}>
                        {item.label}
                      </Radio>
                    ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
        )}

        {formSchema.assignNo && (
          <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.assignNo.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.assignNo.validators, formSchema.assignNo.label)}
            </ControlLabel>
            <Input
              name={formSchema.assignNo.name}
              defaultValue={formSchema.assignNo.value}
              inputRef={register(isValidators(formSchema.assignNo.validators))}
              placeholder={'ระบุ' + formSchema.assignNo.label}
            />
          </Col>
        )}

        {formSchema.refFile && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.refFile.validators) && 'required')}
              >
                {formSchema.refFile.label}
              </ControlLabel>
              <ErrorMessage error={errors.refFile} />
              <Controller
                name={formSchema.refFile.name}
                control={control}
                defaultValue={
                  !isEmpty(formSchema.refFile.value) ? [formSchema.refFile.value] : undefined
                }
                rules={formSchema.refFilePath ? null : isValidators(formSchema.refFile.validators)}
                render={(props) => {
                  return (
                    <Uploader
                      draggable
                      autoUpload={false}
                      multiple={false}
                      fileList={props.value || []}
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          let files = []
                          files.push(fileList[fileList.length - 1])
                          props.onChange(files)
                        }
                      }}
                    >
                      <div>
                        <div
                          style={{ lineHeight: '50px' }}
                          className={classNames('uploader', `${theme[0]}-background`)}
                        >
                          <Icon size="4x" icon="upload2" />
                          <small className="uploder__text">
                            <p style={{ wordBreak: 'break-word' }}>
                              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                            </p>
                          </small>
                        </div>
                      </div>
                    </Uploader>
                  )
                }}
              />
            </Col>
          </Row>
        )}

        {formSchema.refFilePath && formSchema.id && (
          <Row style={{ marginTop: 10 }}>
            <div style={{ width: '100%' }}>
              <div style={{ marginTop: 10 }}>
                <ButtonGroup>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon appearance="ghost" icon="eye" className="bt-gost-icon-radius" />}
                    onClick={() => {
                      handleFile('view', formSchema.id, 'หนังสือแต่งตั้ง')
                    }}
                  >
                    แสดง
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    icon={
                      <Icon
                        appearance="ghost"
                        icon="download"
                        className="bt-gost-icon-none-radius"
                      />
                    }
                    onClick={() => {
                      handleFile('download', formSchema.id, 'หนังสือแต่งตั้ง')
                    }}
                  >
                    ดาวน์โหลด
                  </IconButton>
                  {/* <IconButton
                            icon={<Icon appearance="ghost" icon="trash" />}
                            onClick={() => {
                              setIsDeleteIdCard(true)
                              setValue('isDeleteIdCard', true)
                            }}
                          >
                            ลบไฟล์
                          </IconButton> */}
                </ButtonGroup>
              </div>
            </div>
          </Row>
        )}

        {fileErr && (
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
            <Message
              showIcon
              type="error"
              description={fileErr}
              closable
              onClose={() => {
                setFileErr('')
              }}
            />
          </Col>
        )}

        {formSchema.accountType && (
          <Col xs={24} sm={12} md={12} lg={12} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                'style-text-lable',
                isRequired(formSchema.accountType.validators) && 'required'
              )}
            >
              {formSchema.accountType.label}
            </ControlLabel>
            <ErrorMessage error={errors.accountType} />
            <Controller
              name={formSchema.accountType.name}
              control={control}
              defaultValue={formSchema.accountType.value}
              rules={isValidators(formSchema.accountType.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.accountType.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'เลือก' + formSchema.accountType.label}
                    placement={'autoVerticalStart'}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        )}

        {formSchema.expertiseType && (
          <Col xs={24} sm={12} md={12} lg={12} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                'style-text-lable',
                isRequired(formSchema.expertiseType.validators) && 'required'
              )}
            >
              {formSchema.expertiseType.label}
            </ControlLabel>
            <ErrorMessage error={errors.expertiseType} />
            <Controller
              name={formSchema.expertiseType.name}
              control={control}
              defaultValue={formSchema.expertiseType.value}
              rules={isValidators(formSchema.expertiseType.validators)}
              render={(props) => {
                return (
                  <CheckPicker
                    data={formSchema.expertiseType.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'เลือก' + formSchema.expertiseType.label}
                    placement={'autoVerticalStart'}
                    renderExtraFooter={() => (
                      <Checkbox
                        style={{ marginLeft: 2 }}
                        inline
                        //indeterminate={value.length > 0 && value.length < allValue.length}
                        checked={props.value.length === allValue.length}
                        onChange={(value, checked) => {
                          setValue(formSchema.expertiseType.name, checked ? allValue : [])
                        }}
                      >
                        เลือกทั้งหมด
                      </Checkbox>
                    )}
                    onChange={(value) => {
                      setExpertiseTypeSelected(value)
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        )}

        {formSchema.bankName && (
          <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.bankName.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.bankName.validators, formSchema.bankName.label)}
            </ControlLabel>
            <Input
              name={formSchema.bankName.name}
              defaultValue={formSchema.bankName.value}
              inputRef={register(isValidators(formSchema.bankName.validators))}
              placeholder={'ระบุ' + formSchema.bankName.label}
            />
          </Col>
        )}

        {formSchema.branchOfBank && (
          <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.branchOfBank.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.branchOfBank.validators, formSchema.branchOfBank.label)}
            </ControlLabel>
            <Input
              name={formSchema.branchOfBank.name}
              defaultValue={formSchema.branchOfBank.value}
              inputRef={register(isValidators(formSchema.branchOfBank.validators))}
              placeholder={'ระบุ' + formSchema.branchOfBank.label}
            />
          </Col>
        )}

        {formSchema.bankAccountNo && (
          <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.bankAccountNo.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.bankAccountNo.validators, formSchema.bankAccountNo.label)}
            </ControlLabel>
            <Controller
              name={formSchema.bankAccountNo.name}
              control={control}
              defaultValue={formSchema.bankAccountNo.value}
              rules={isValidators(formSchema.bankAccountNo.validators)}
              render={(props) => {
                return (
                  <Input
                    placeholder={formSchema.bankAccountNo.label}
                    value={props.value}
                    maxLength={getMaxLengthData(formSchema.bankAccountNo.validators).value}
                    onChange={(value, e) => {
                      if (isNaN(value)) {
                        return
                      }
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
            {/* <Input
              name={formSchema.bankAccountNo.name}
              defaultValue={formSchema.bankAccountNo.value}
              inputRef={register(isValidators(formSchema.bankAccountNo.validators))}
              placeholder={'ระบุ' + formSchema.bankAccountNo.label}
            /> */}
          </Col>
        )}
      </Row>

      <>
        <hr />
        {isError && <Message showIcon type="error" description={isError} />}
        <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึกการ' + formSchema.hedaer}</SaveButton>

        <CancelButton onClick={() => onCancel()}>ยกเลิก</CancelButton>
      </>
    </Panel>
  )
}
